<template>
  <ClientOnly>
    <div to="#modal-root">
      <ModalBase
        v-for="modal of modalState"
        :key="modal.id"
        v-slot="{ hide }"
        @hide="() => {
          modal.hide();
        }"
      >
        <component
          :is="modal.component"
          v-bind="{ ...modal.props }"
          @hide="() => {
            modal.props?.onHide?.();
            hide();
          }"
        />
      </ModalBase>
    </div>
  </ClientOnly>
</template>

<script setup lang="ts">
import { modalStateKey } from '.';
import ModalBase from './ModalBase.vue';

const modalState = inject(modalStateKey);
</script>

<style lang="scss">
#modal-root {
  position: fixed;
  z-index: 9999999;
}
</style>
